intra_module.factory('FileBank', function($resource, hub_api_url) {
    const url     = `${hub_api_url}/intra/my-files`;
    const params  = { };
    const actions = {
        query: {
            method:          'GET',
            isArray:         false,
        }
    };

    return $resource(url, params, actions);
});
